<script setup>
import { ref } from "vue";
import { auth_user } from "@/services/auth";
import { useRouter } from "vue-router";
import { swalError } from "@/helper";
import { ability } from "@/plugins/ability";

const router = useRouter();
const active = ref(true);
const loading = ref(false);
const user = ref({});

async function login() {
  loading.value = true;
  let response = await auth_user(user.value);
  console.log("🚀 ~ login ~ response:", response);
  loading.value = false;
  if (response.error) {
    swalError(response.message || response.error);
    return;
  }

  // Store user data in localStorage
  // The response.data should contain the user attributes from JSON:API
  if (response.data) {
    localStorage.setItem("user_data", JSON.stringify(response.data));
    ability.update(response.data);
    router.push({ name: "dashboard" });
  } else {
    swalError("Invalid response from server");
    return;
  }
}

function show() {
  active.value = !active.value;
}
</script>

<template>
  <div class="login-bg d-flex justify-content-center align-items-center">
    <div>
      <div class="mb-3 text-center">
        <a class="logo">
          <img
            class="img-fluid"
            src="../assets/images/logo/logo.png"
            width="200"
            alt="looginpage"
          />
        </a>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="login-main">
            <form class="theme-form" @submit.prevent="login()">
              <h4>Welcome home</h4>
              <p>Enter your email & password to proceed</p>
              <div class="form-group">
                <label class="col-form-label">Email Address</label>
                <input
                  class="form-control"
                  type="email"
                  required=""
                  placeholder="abc@mail.com"
                  v-model="user.email"
                />
              </div>
              <div class="form-group">
                <label class="col-form-label">Password</label>
                <div class="form-input position-relative">
                  <input
                    class="form-control"
                    :type="active ? 'password' : 'text'"
                    name="login[password]"
                    required=""
                    placeholder="*********"
                    v-model="user.password"
                  />
                  <div class="show-hide">
                    <span
                      :class="active ? 'show' : 'hide'"
                      @click.prevent="show"
                    >
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input id="checkbox1" type="checkbox" />
                  <label class="text-muted" for="checkbox1"
                    >Remember password</label
                  >
                </div>
                <button type="submit" class="btn btn-primary btn-block">
                  <span v-if="loading">
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </span>
                  <span v-else> Sign in </span>
                </button>
              </div>
              <p class="mt-4 mb-0">
                Don't have account?
                <router-link class="ms-2" tag="a" to="/register">
                  Create Account
                </router-link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login-bg {
  background-color: #f5f5f5;
  height: 100vh;
}
</style>
